import { jsx as _jsx } from "react/jsx-runtime";
import 'shared/styles/GlobalNavigation.css';
import 'shared/styles/RegistrationSuccess.css';
import './styles/App.css';
import RecoverPage from './components/RecoverPage';
const App = () => {
    return (_jsx("div", { className: "app", children: _jsx(RecoverPage, {}) }));
};
export default App;
